export const APP_MEDIAQUERY = Object.freeze({
  desktopLG: 1200,
  desktop: 992,
  tablet: 768,
  mobile: 480
});
